import React from 'react';
import {
    Select,
    Stack,
    TextField,
} from '@shopify/polaris';
import { SelectFilterTypes } from '../common/Helpers';

const variantConditions = [
    { label: 'of all variants', value: 'AllVariants' },
    { label: 'of any variant', value: 'AnyVariant' },
    { label: 'of no variants', value: 'NoVariants' }
];

const quantityConditions = [
    { label: 'is equal to', value: 'EqualTo' },
    { label: 'is greater than', value: 'GreaterThan' },
    { label: 'is greater than or equal to', value: 'GreaterThanOrEqual' },
    { label: 'is less than or equal to', value: 'LessThanOrEqual' },
    { label: 'is less than', value: 'LessThan' }
];

class ProductInventoryQuantityFilterComponent extends React.Component {
    state = {};

    render() {

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected) => this.onFilterTypeChange(selected)}
                />
                <Select
                    options={variantConditions}
                    value={this.props.filter.variantCondition}
                    onChange={(selected) => this.onVariantConditionChange(selected)}
                />
                <Select
                    options={quantityConditions}
                    value={this.props.filter.quantityCondition}
                    onChange={(selected) => this.onQuantityConditionChange(selected)}
                />
                <TextField
                    placeholder="Quantity"
                    type="number"
                    value={this.props.filter.quantity.toString()}
                    onChange={(newValue) => this.onQuantityChange(newValue)}
                />
            </Stack>
        );
    }

    onFilterTypeChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.filterType = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onVariantConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.variantCondition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onQuantityConditionChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.quantityCondition = newValue;

        this.props.onFilterUpdated(newFilter);
    }

    onQuantityChange = (newValue) => {
        let newFilter = JSON.parse(JSON.stringify(this.props.filter));
        newFilter.quantity = parseInt(newValue);

        this.props.onFilterUpdated(newFilter);
    }
}

export default ProductInventoryQuantityFilterComponent;
